export interface Character {
  id: string;
  name: string;
  emoji: string; // 에러 텍스트 또는 이모지
  duration: number; // ms
  score: number;
  color: string; // 배경색
  isShark?: boolean; // 상어 여부
  imagePath?: string; // 이미지 경로
}

export const GAME_CHARACTERS: Character[] = [
  {
    id: 'bug-1',
    name: 'Bug 1',
    emoji: '',
    duration: 700, // 제일 빠름!
    score: 50,
    color: 'transparent',
    imagePath: 'z_01.png', // 고슈
  },
  {
    id: 'bug-2',
    name: 'Bug 2',
    emoji: '',
    duration: 1000,
    score: 10,
    color: 'transparent',
    imagePath: 'z_02.png', // 우드
  },
  {
    id: 'bug-3',
    name: 'Bug 3',
    emoji: '',
    duration: 900,
    score: 30,
    color: 'transparent',
    imagePath: 'z_05.png', // 도니
  },
  {
    id: 'bug-4',
    name: 'Bug 4',
    emoji: '',
    duration: 800,
    score: 40,
    color: 'transparent',
    imagePath: 'z_06.png', // 올리
  },
  {
    id: 'shark',
    name: '상어',
    emoji: '🦈',
    duration: 1200, // 좀 더 오래 있어서 클릭 유도
    score: -100, // 감점!
    color: 'transparent',
    isShark: true,
  },
];

export const GAME_CONFIG = {
  TOTAL_TIME: 45, // 45초
  GRID_SIZE: 9, // 3x3 그리드
  SPAWN_INTERVAL_MIN: 300, // 빠르게 스폰
  SPAWN_INTERVAL_MAX: 700, // 빠르게 스폰
  MAX_ACTIVE_CHARACTERS: 4, // 동시에 최대 4개
} as const;

// 랭킹 관련 타입 및 데이터
export interface RankingEntry {
  rank: number;
  nickname: string;
  comment: string;
  score: number;
}

export interface RankingData {
  daily: RankingEntry[];
  weekly: RankingEntry[];
  monthly: RankingEntry[];
}
